export enum REQUEST_STATE {
  RETRIAL = 'RETRIAL',
  REQUEST = 'REQUEST',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
  DORMANT = 'DORMANT',
  COMPLETE = 'COMPLETE',
}

export const weekStringToNumber: {
  [label in WeekDayString]: WeekDayNumber;
} = {
  mon: 1,
  tue: 2,
  wed: 3,
  thu: 4,
  fri: 5,
  sat: 6,
  sun: 7,
};

export const weekNumberToString: {
  [label in WeekDayNumber]: WeekDayString;
} = {
  1: 'mon',
  2: 'tue',
  3: 'wed',
  4: 'thu',
  5: 'fri',
  6: 'sat',
  7: 'sun',
};

export const weekDays: WeekDay[] = [
  { label: 'mon', number: 1 },
  { label: 'tue', number: 2 },
  { label: 'wed', number: 3 },
  { label: 'thu', number: 4 },
  { label: 'fri', number: 5 },
  { label: 'sat', number: 6 },
  { label: 'sun', number: 7 },
];

export const DATE_FORMAT = 'do MMM, yyyy';
export const TIME_FORMAT = 'HH:mm a';

export enum AuthScreens {
  IMPORT_DATA,
  SSO_AUTHENTICATION,
  SSO_LOGIN,
  GET_STARTED,
  GET_EMAIL,
  VERIFY_CODE,
  SET_PASSWORD,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  GET_PASSWORD,
  LMS_AUTHORIZATION,
}
